/**
 * Get Taxonomy Review Stories
 * @param {string} username
 * @returns {stories[]} - return array of stories
 */

const TAXONOMY_VERSION = 0;

const clientAPICall = url => {
  return Promise.resolve(
    $.ajax({
      type: "GET",
      url: url,
      xhrFields: {
        withCredentials: true
      }
    })
  );
};

module.exports = function(username) {
  return new Promise(function(resolve, reject) {
    const url = `${
      wattpad?.apiDomain
    }/writing/v1/writers/${username}/stories?taxonomyVersion=${TAXONOMY_VERSION}`;

    clientAPICall(url)
      .then(stories => {
        return resolve(stories);
      })
      .catch(err => {
        return reject(err);
      });
  });
};
